import type { FC } from 'react'
import React, { memo } from 'react'
import classNames from 'classnames'
import { ConsultingForm } from '@/components/composed'
import { messages } from './messages'
import type { ILandingConsultingProps } from './types'
import './styles.scss'

const LandingConsulting: FC<ILandingConsultingProps> = props => {
  const { className, purpose } = props

  return (
    <section className={classNames(className, 'landingConsulting')}>
      <div className="page-wrapper landingConsulting__wrapper">
        <div className="landingConsulting__heading">
          <h2>{messages.title}</h2>
          {messages.description}
        </div>
        <ConsultingForm className="landingConsulting__form" purpose={purpose} />
      </div>
    </section>
  )
}

export default memo(LandingConsulting)
